<app-admin-list-page [title]="'Meet days' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addMeetday()">
    {{'Add' | translate}}
  </button>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
